import styled from "styled-components";
import { CssRule } from "../../../../themes/architecture/css-helpers/css-rule";
import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";

const BalanceButtonsGroupDefaultBox = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
`;

const BalanceButtonsGroupHarrahsWsopBox = styled(BalanceButtonsGroupDefaultBox)`
    ${CssRule.For.mobile.build()} &{
        background: transparent;
    }
`;

const BalanceButtonsGroupMrGreenWsopBox = styled(BalanceButtonsGroupDefaultBox)`
    ${CssRule.For.mobile.build()} &{
        background: transparent;
    }
`;

export const BalanceButtonsGroupBox = styledByTheme(BalanceButtonsGroupDefaultBox)
    .forHarrahs(BalanceButtonsGroupHarrahsWsopBox)
    .forWsop(BalanceButtonsGroupHarrahsWsopBox)
    .forMrGreen(BalanceButtonsGroupMrGreenWsopBox)
    .apply();
